import $ from 'jquery'
window.$ = $
$( ->
  # POST NEW JOB MODAL - HANDLES STEPS AND CONDITIONALS
  $('body.manage.jobs #job_location_id, body.manage.jobs #job_department_id').change ->
    if $('input#refresh').length > 0
      $('input#refresh').val('1')
      $(this).closest('form').submit()

  getTemplateInfo = (inp) ->
    if !!inp && inp.length > 0
      selected = inp
    else
      selected = $('input[name="job[clone]"]:checked')
      if !($(selected).length) || ($(selected).attr('id') == 'job_clone_template')
        selected = $('#new-job-form #job_clone_from_template_id_input select')
    if ($(selected).length > 0)
      template_val = selected.val()
      if ($(selected).closest('.builder_data').length > 0)
        unless template_val == 'new'
          template_info = $(selected).closest('.builder_data').data('template-info')[template_val]
    return template_info

  showJobPostStep = (step, prev_step, job_builder_id, default_name_opt) ->
    $("#new-job-form .job-post-step-#{step}").removeClass('hidden d-none')
    $("#new-job-form .job-post-step-#{prev_step}").addClass('hidden d-none')

    if (step == 2)
      $("#title_select_job_builder_#{job_builder_id}").attr('disabled', false)
      $("#title_select_job_builder_#{job_builder_id}").closest('.title-opts').removeClass('hidden d-none')
      if $("#title_select_job_builder_#{job_builder_id} option[value='#{default_name_opt}']").length > 0
        $("#title_select_job_builder_#{job_builder_id}").val(default_name_opt)
      else
        $("#title_select_job_builder_#{job_builder_id} option:first").attr('selected','selected')
    else
      $("[id^='title_select_job_builder_']").attr('disabled', true)
      $("[id^='title_select_job_builder_']").closest('.title-opts').addClass('hidden d-none')

      $("#title_select_job_builder_#{job_builder_id} option:first").attr('selected','selected')
    submitButton = $($('#new-job-form .btn.btn-primary')[0])
    if (step == 2)
      submitButton.text('Create Job').addClass('submit-form')
      submitButton.get(0).setAttribute('data-action', 'click->submit-form#submit')
    else
      submitButton.text('Next').removeClass('submit-form')
      submitButton.get(0).removeAttribute('data-action')

  $('#new-job-form .builder_data input, #new-job-form .builder_data select').change ->
      template_info = getTemplateInfo($(this))
      if !!template_info
        location_id = template_info.location_id
        department_id = template_info.department_id
        if (!!location_id)
          $('#new-job-form #job_location_input select').val(location_id)
        if (!!department_id)
          $('#new-job-form #job_department_input select').val(department_id)

  $(document).on 'click', '#new-job-form .btn.btn-primary:not(.submit-form)', (e)->
    e.preventDefault();
    template_info = getTemplateInfo()
    if !!template_info
      job_builder_id = template_info.job_builder_id
      default_name_opt = template_info.default_name_opt
      if (!!job_builder_id)
        showJobPostStep(2, 1, job_builder_id, default_name_opt)

    return false;

  $(document).on 'click', '#new-job-form [data-dismiss="modal"]', ->
    if $('#new-job-form .job-post-step-2').length > 0
      showJobPostStep(1, 2, null, null)

  if $('.formtastic.job .full_location').length > 0
    $('.formtastic.job #job_location_id').change ->
      if $.inArray(parseInt($(this).val()), $('#new-job-form .full_location').data('open_zipcode')) > -1
        if $('.formtastic.job .full_location').is(':hidden')
          $('.formtastic.job .full_location').slideDown('fast')
      else
        if $('.formtastic.job .full_location').is(':visible')
          $('.formtastic.job .full_location').slideUp('fast')


  $(document).on 'show.bs.modal', '#new-job-form', ->
    $('#new_job_clone input[type=radio]').first().prop('checked',true)
    toggleMultiLocation()
    if $('#new-job-locations.in').length > 0
      $('#show-single-location').trigger('click')
  $(document).on 'change', '#new-job-locations .select-all', ->
    if $(this).prop('checked')
      $('#job_location_input.check_boxes .checkbox input').prop('checked', true).trigger('change')
    else
      $('#job_location_input.check_boxes .checkbox input').prop('checked', false).trigger('change')
    false
  $(document).on 'change', ['select#job_clone_from_template_id', '#job_clone_template', '#job_clone_new'], ->
    toggleMultiLocation()


  toggleMultiLocation = ->
    if (
        ($('select#job_clone_from_template_id').val() == 'new') &&
        ($('#job_clone_template').is(':checked'))
       ) ||
       ($('#job_clone_new').is(':checked'))
      $('a[href="#new-job-locations"]').hide()
      if $('#new-job-locations.in').length > 0
        $('#show-single-location').trigger('click')
    else
      $('a[href="#new-job-locations"]').show()

  preventSubmit = ->
    $('#new-job-form .btn.submit-form').prop(
      'disabled',
      $('#job_location_input.check_boxes .checkbox input:checkbox:checked').length < 1
    )

  $(document).on 'show.bs.collapse', '#new-job-locations', ->
    $('#new-job-form .btn.submit-form').prop('disabled', true)
    $('#job_location_input.check_boxes .checkbox input').on 'change', preventSubmit
  $(document).on 'hide.bs.collapse', '#new-job-locations', ->
    $('#job_location_input.check_boxes .checkbox input').prop('checked', false)
    $('#new-job-form .btn.submit-form').prop('disabled', false)
    $('#job_location_input.check_boxes .checkbox input').off 'change', preventSubmit
)
